import React, { Component } from 'react';
import {
    Nav, NavItem, NavLink,
    TabContent, Input
} from 'reactstrap';
import classnames from 'classnames';
import './Profile.css';
import { Data } from '../Data';
import { AbsenceDataService } from '../services/AbsenseDataService';
import { ThemeSwitcher } from './ThemeSwitcher';
import { AccountInformation } from './AccountInformation';
import { PersonalInformation } from './PersonalInformation';
import { PayrollInformation } from './PayrollInformation';
import { HRInformation } from './HRInformation';
import { Consent } from './Consent';
import { ProfileSelector } from './ProfileSelector';
import { TitleCaseFormat } from '../shared/TitleCaseFormat';

export class Profile extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.buildDistrictOptions = this.buildDistrictOptions.bind(this);
        this.state = {
            activeTab: '1',
            districts: [],
            employee: {},
            district: -1,
            user: {},
            loading: true,
            showAbsence: true,
            showPayroll: true,
            showW2: true
        };
        this.dataService = new Data();
        this.absenceDataSerive = new AbsenceDataService();
        this.buildNavItem = this.buildNavItem.bind(this);
        this.getAbsenceInfo = this.getAbsenceInfo.bind(this);
        this.getAbsenceSummary = this.getAbsenceSummary.bind(this);
        this.getEmployeeObject = this.getEmployeeObject.bind(this);
        this.getUserObject = this.getUserObject.bind(this);
        this.getAvailableDistricts = this.getAvailableDistricts.bind(this);
        this.changeDistrict = this.changeDistrict.bind(this);
        this.buildDistrictSection = this.buildDistrictSection.bind(this);
        this.updateDistrictSettings = this.updateDistrictSettings.bind(this);
        this.getAvailableDistricts();
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    getEmployeeObject() {
        this.dataService.getEmployee().then((data) => {
            this.setState({ employee: data || {} });
        });
    }

    getAbsenceInfo() {
        return this.absenceDataSerive.getAbsenceInfo(this.state.district)
            .then(data => {
                var correctedData = data.map(absence => {
                    return Object.assign(absence, {
                        toDate: new Date(absence.toDate),
                        fromDate: new Date(absence.fromDate)
                    });
                });
                this.setState({ absenceInfo: correctedData });
                return correctedData;
            });
    }

    getAbsenceSummary() {
        return this.absenceDataSerive.getAbsenceSummary(this.state.district)
            .then(data => {
                this.setState({ absenceSummary: data });
            });
    }

    getUserObject() {
        return this.dataService.getUser().then((data) => {
            this.setState({ user: data });
            return data;
        });
    }

    getAvailableDistricts() {
        if (this.state.districts.length === 0) {
            this.dataService.getDistricts().then((data) => {
                var districtno = data[0].number;
                this.setState({ districts: data, district: districtno }, () => {
                    localStorage.setItem('District', districtno);
                    this.setState({ loading: false });
                    this.getAbsenceInfo();
                    this.getAbsenceSummary();
                    this.getEmployeeObject();
                    this.getUserObject();
                    this.updateDistrictSettings();
                });
            });
        }
    }

    updateDistrictSettings() {
        this.dataService.getDistrictSettings()
            .then((data) => {
                if (data) {
                    this.setState({ showAbsence: data.absenceEnabled, showPayroll: data.payrollEnabled, showW2: data.w2Enabled })
                }
            });
    }

    buildDistrictOptions() {
        var districtOptions = [];
        for (let i = 0; i < this.state.districts.length; i++) {
            districtOptions.push(
                <option
                    key={this.state.districts[i].number}
                    value={this.state.districts[i].number}>
                    {this.state.districts[i].name}
                </option>)
        }
        return (districtOptions);
    }

    buildNavItem(tabNumber, title) {
        return (
            <NavItem>
                <NavLink title={"Menu tab for " + title}
                    className={classnames({
                        active: this.state.activeTab === tabNumber,
                        'k-link': true,
                    })}
                    onClick={() => { this.toggle(tabNumber); }}>
                    {title}
                </NavLink>
            </NavItem>);
    }

    changeDistrict(e) {
        localStorage.setItem('District', e.target.value);
        this.setState({ district: e.target.value }, () => {
            this.getAbsenceInfo();
            this.getAbsenceSummary();
            this.getEmployeeObject();
            this.updateDistrictSettings();
        });
    }

    buildDistrictSection() {
        if (this.state.districts.length > 1)
            return (
                <Input type="select" title="District drop down selector"
                    onChange={this.changeDistrict}
                    defaultValue={this.state.district}
                    key={this.state.districts}
                >
                    {this.buildDistrictOptions()}
                </Input>
            );
        else if (this.state.districts.length === 1)
            return (<div>{this.state.districts[0].name}</div>);
        else
            return (<div></div>);
    }

    render() {
        let data;
        if (this.state.loading) {
            data =
                (<div></div>)
        } else {
            data =
                (<div className="container margin-top-10">
                    <div className="row">
                        <div className="col-sm-12 col-md-3 text-center k-widget">
                            <section style={{ margin: '10px' }}>
                                <div>
                                    <img src={this.props.profileImage} alt="My Avatar"
                                        title="Avatar for Phoenix"
                                        className="w-75" tabIndex="0" /><br />
                                    <ProfileSelector
                                        {...this.props}
                                        key={this.props.profileImage}
                                        employee={this.state.employee}
                                    />
                                </div>
                                <strong>
                                    <TitleCaseFormat>
                                        <employee-name>
                                            <span>{this.state.employee.firstName}</span> <span>{this.state.employee.middleInitial}</span> <span>{this.state.employee.lastName}</span>
                                        </employee-name>
                                    </TitleCaseFormat>
                                </strong>
                                <p className="textTransform">
                                    <TitleCaseFormat>
                                        {this.state.employee.jobTitle}
                                    </TitleCaseFormat>
                                    <br />
                                    {this.state.employee.jobCategoryName}
                                </p>
                                <h6>District</h6>
                                {this.buildDistrictSection()}
                                <div id="updatethemebutton" className="margin-top-10">
                                <label id="themeChooserLabel" htmlFor="themeChooser">Selected Theme</label>
                                    <ThemeSwitcher changeThemeCb={this.props.changeThemeCb}
                                        theme={this.props.theme}
                                        key={this.props.theme}
                                    ></ThemeSwitcher>
                                </div>
                            </section>
                        </div>
                        <div className="col-sm-12 col-md-9">
                            <Nav tabs className="k-tabstrip-top">
                                {this.buildNavItem('1', 'User Information')}
                                {this.buildNavItem('2', 'Basic Information')}
                                {this.buildNavItem('3', 'HR Information')}
                                {this.buildNavItem('4', 'Payroll Information')}
                                {this.buildNavItem('5', 'Consent')}
                            </Nav>
                            <TabContent activeTab={this.state.activeTab}>
                                <AccountInformation user={this.state.user} />
                                <PersonalInformation employee={this.state.employee} />
                                <HRInformation
                                    absenceSummary={this.state.absenceSummary}
                                    absenceInfoCb={this.getAbsenceInfo}
                                    employee={this.state.employee}
                                    district={this.state.district}
                                    showAbsence={this.state.showAbsence}
                                />
                                <PayrollInformation
                                    district={this.state.district}
                                    w2Consent={this.state.user.w2Consent}
                                    apdConsent={this.state.user.apdConsent}
                                />
                                <Consent
                                    getUserData={this.getUserObject}
                                    w2Consent={this.state.user.w2Consent}
                                    apdConsent={this.state.user.apdConsent}
                                    key={this.state.user.w2Consent + this.state.user.apdConsent}
                                />
                            </TabContent>
                        </div>
                    </div>
                </div>)
        }

        return (<div>{data}</div>);
    }
}
